const hasToken = () => {
  const authenticated = localStorage.getItem('authenticated');
  if (authenticated) return true;
  if (!authenticated) return;
}

export default hasToken;
